import React from 'react';
import MenuPage from '../../pages/MenuPage';
import { Grid, Row, Col } from 'react-flexbox-grid';
import translate from '../../lib/i18n/translate'
import {ChartSlider} from "../chart/ChartSlider";
import TransactionList from "./TransactionList";
import {LoomisColors} from "../../lib/LoomisColors";
import FontIcon from 'material-ui/FontIcon';

import './TransactionDay.css'
import {ROOT_URL} from "../../store/actions/util";

const TransactionDay = (props, transactionday, branchId, day, mainCurrency, salesByCurrencyHour, mobile) => {

    const {strings} = props

    const exportIconStyle = {
        color:LoomisColors.white,
        marginTop: 6,
        marginRight: 16,
    }

    const exportStyle = {
        color:LoomisColors.white,
        marginTop: 6
    }

    const handleExport = () => {

        let url = ROOT_URL+ "/api/v1/branches/" + props.branchId + "/transactions/" + props.day + "/export";
        window.open(url);
    };

    const Menu = () => (
        <div>
            <FontIcon className="ExportTransactionsIcon material-icons" onClick={()=>handleExport()} style={exportIconStyle}>file_download</FontIcon>
            <div className="ExportTransactions" style={exportStyle} onClick={()=>handleExport()}>{strings.ExportTransactions}</div>
        </div>
    );

    return (
        <MenuPage title={props.transactionday.branchName + " --- "  + props.transactionday.day}  menu={<Menu/>} onBackClick={()=>{props.history.goBack()}}>
            <div className="container">
                <Grid fluid>
                    <Row>
                        <Col xs={12}>
                            <ChartSlider periodLength={mobile?7:undefined} mainCurrency={props.mainCurrency} salesByHour={props.salesByCurrencyHour} />
                        </Col>

                    </Row>
                </Grid>
                <Grid fluid className="noXsPadding">
                    <Row>
                        <Col xs={12}>
                            <TransactionList data={props.transactions}/>
                        </Col>
                    </Row>

                </Grid>
            </div>
        </MenuPage>
    )
};

export default translate('TransactionDay')(TransactionDay);


// WEBPACK FOOTER //
// ./src/components/transactionDay/TransactionDay.js